// eslint-disable-next-line import/prefer-default-export
export const getDynamicMatchSubmissionMetadata = ({
  dynamicMatches,
  brandId,
}) => {
  if (!dynamicMatches?.length) {
    return { submissionType: undefined, dynamicBrandMatch: undefined };
  }

  const index = dynamicMatches.findIndex((match) => match.brandId === brandId);
  if (index < 0) {
    return { submissionType: undefined, dynamicBrandMatch: undefined };
  }

  return {
    submissionType:
      index === 0
        ? 'selectAndConnectPrimarySubmission'
        : 'selectAndConnectSecondarySubmission',
    dynamicBrandMatch: {
      brandId: dynamicMatches[index].brandId,
      brandName: dynamicMatches[index].brandName,
      supplierId: dynamicMatches[index].supplierId,
      priorityOrderPosition: index + 1,
      matchLevel: dynamicMatches[index].matchLevel,
    },
  };
};
